import * as Yup from 'yup';

import { passwordRegex } from '../../../../constants';

export const customerAddUserFormYopValidation = () => {
  return Yup.object().shape({
    firstName: Yup.string().required('required'),
    lastName: Yup.string().required('required'),
    username: Yup.string().required('required').email('incorrectEmail'),
    password: Yup.string().required('required').min(15, 'min15').matches(passwordRegex, 'passwordPattern'),
  });
};

export const customerEditUserFormYopValidation = () => {
  return Yup.object().shape({
    firstName: Yup.string().required('required'),
    lastName: Yup.string().required('required'),
    username: Yup.string().required('required').email('incorrectEmail'),
    password: Yup.string()
      .nullable()
      .test(
        'password',
        'Password must be at least 15 characters long and match the required pattern',
        function (value) {
          if (value && value.length > 0) {
            return Yup.string().min(15).matches(passwordRegex, 'passwordPattern').isValidSync(value);
          }
          return true;
        },
      ),
  });
};
